/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  KillswitchCreateRequest,
  KillswitchCreateRequest$Outbound,
  KillswitchCreateRequest$outboundSchema,
} from "../components/killswitchcreaterequest.js";

export type KillswitchesCreateSecurity = {
  sessionHeaderGramSession: string;
};

export type KillswitchesCreateRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  killswitchCreateRequest: KillswitchCreateRequest;
};

/** @internal */
export type KillswitchesCreateSecurity$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const KillswitchesCreateSecurity$outboundSchema: z.ZodMiniType<
  KillswitchesCreateSecurity$Outbound,
  KillswitchesCreateSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function killswitchesCreateSecurityToJSON(
  killswitchesCreateSecurity: KillswitchesCreateSecurity,
): string {
  return JSON.stringify(
    KillswitchesCreateSecurity$outboundSchema.parse(killswitchesCreateSecurity),
  );
}

/** @internal */
export type KillswitchesCreateRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  KillswitchCreateRequest: KillswitchCreateRequest$Outbound;
};

/** @internal */
export const KillswitchesCreateRequest$outboundSchema: z.ZodMiniType<
  KillswitchesCreateRequest$Outbound,
  KillswitchesCreateRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    killswitchCreateRequest: KillswitchCreateRequest$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      killswitchCreateRequest: "KillswitchCreateRequest",
    });
  }),
);

export function killswitchesCreateRequestToJSON(
  killswitchesCreateRequest: KillswitchesCreateRequest,
): string {
  return JSON.stringify(
    KillswitchesCreateRequest$outboundSchema.parse(killswitchesCreateRequest),
  );
}
